import { httpPost } from "../http-requests";

export async function login(username, password) {
    const dataObject = { username, password };
    const response = await httpPost("/api/login", null, dataObject, { withCredentials: true });
    return response;
}